import { render, staticRenderFns } from "./EnterDispatchNumber.vue?vue&type=template&id=789da460&scoped=true&"
import script from "./EnterDispatchNumber.vue?vue&type=script&lang=js&"
export * from "./EnterDispatchNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789da460",
  null
  
)

export default component.exports